<template>
<div class="rotated-img" ref="rotatedImg" v-on:mousemove="mousePosition">
  <img class="img-fluid" src="@/assets/images/works/img-loading.svg">
  <div class="img-bg-white">
  </div>
  <template v-if="isMounted">
  <img v-for="i in 8" :key="i" class="thumbnail" :class="rotationClass(i)" :src="loadSrc(i)" @load="load"/>
  </template>

  <div class="opening-effect-cover-slide-right" :class="completeLoading? 'show': ''">
  </div>

</div>
</template>

<script>
import isMobile from 'ismobilejs'
import { mapState } from 'vuex'

export default {
  props: {
    directoryNo: {
      type: String,
      default: '1'
    },
    rotationLv: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      isMobile,
      isMounted: false,
      loadedCounter: 0,
      isShown: false,
      rotationLvPc: 1
    }
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    ...mapState({
      homeSwiperIndex: state => state.homeSwiperIndex,
    }),
    completeLoading() {
      // if (this.isShown) return true
      if(this.loadedCounter >= 8) {
        if (this.isShown) {
          return true
        }
      }
      return false
    },

  },
  methods: {
    loadSrc(index) {
      if (this.isMobile().phone) {
        return './images/works/'+ this.directoryNo +'/'+ index +'@xs.jpg'
      } else {
        return './images/works/'+ this.directoryNo +'/'+ index +'.jpg'
      }
    },
    rotationClass(index) {
      if (this.isMobile().any) {
        return this.rotationLv == index? '': 'opacity-0'
      } else {
        return this.rotationLvPc == index? '': 'opacity-0'
      }
    },
    load() {
      this.loadedCounter++
    },
    openingEffect() {
      // console.log('opening!Effect!')
      this.isShown = true
    },
    mousePosition: function(event) {
      if (this.isMobile().any) {
        return
      }
      const w = this.$refs.rotatedImg.clientWidth
      const x = event.offsetX
      this.rotationLvPc = Math.floor(x / w * 8.0) + 1
      if (this.rotationLvPc > 8) {
        this.rotationLvPc = 8
      } else if (this.rotationLvPc < 1) {
        this.rotationLvPc = 1
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.rotated-img {
  position: relative;
  .img-bg-white {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  .thumbnail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    transition: opacity 0.05s;
    opacity: 1;
    &.opacity-0 {
      opacity: 0;
    }
  }
  .hover-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    span {
      display: block;
      position: absolute;
      background-color: #000;
    }
    .top {
      top: 0;
      left: 0;
      width: 0%;
      transition: width 0.3s;
      height: 1px;
    }
    .bottom {
      bottom: 0;
      right: 0;
      width: 0%;
      transition: width 0.3s;
      height: 1px;
    }
    .left {
      bottom: 0;
      left: 0;
      height: 0%;
      transition: height 0.3s;
      width: 1px;
    }
    .right {
      top: 0;
      right: 0;
      height: 0%;
      transition: height 0.3s;
      width: 1px;
    }
  }
  &:hover {
    cursor: zoom-in;
    .hover-layer {
      .top, .bottom {
        width: 100%;
      }
      .left, .right {
        height: 100%;
      }
    }
  }
}
</style>